import i18n from "../i18n";
import { terminology } from "../store/terminology.module.js";

const { t, te } = i18n.global;

const TERMINOLOGY_I18N = {
    estimates: { singular: "estimate", plural: "estimates" },
    creditMemo: { singular: "creditMemo", plural: "creditMemos" },
    journalEntry: { singular: "journalEntry", plural: "journalEntries" },
    workOrder: { singular: "workOrder", plural: "workOrders" },
    fixAsset: { singular: "fixAsset", plural: "fixAssets" },
    salesReciept: { singular: "salesReciept", plural: "salesReciepts" },
    fundReceived: { singular: "fundReceived", plural: "fundsReceived" },
    invoiceBuilder: { singular: "invoiceBuilder", plural: "invoiceBuilders" },
    messageTemplate: { singular: "messageTemplate", plural: "messageTemplates" },
    emailTemplate: { singular: "emailTemplate", plural: "emailTemplates" },
    emailSignature: { singular: "emailSignature", plural: "emailSignatures" },
    warehouseLocation: { singular: "warehouseLocation", plural: "warehouseLocations" },
  };
  export function localizedTerminology() {
    const raw = terminology.state.terminologies;
    const result = {};
  
    for (const domain of Object.keys(raw)) {
      const terms = raw[domain];
      const keys = TERMINOLOGY_I18N[domain] || {
        singular: domain,
        plural: `${domain}s`,
      };
  
      result[domain] = {
        get singular() {
          return te(keys.singular) ? t(keys.singular) : terms.singular;
        },
        get plural() {
          return te(keys.plural) ? t(keys.plural) : terms.plural;
        },
        vowel: terms.vowel,
      };
    }
  
    return result;
  }